<div class="ap-explain">
    <button [attr.aria-expanded]="showExplanation()" class="ap-explain__terms" (click)="toggle()" data-testid="explanation-container">
        @if (termSentence()) {
            <span class="ap-explain__term" data-testid="explanation-term">{{ termSentence() }}</span>
        }
        <span class="ap-explain__term--last"
            >{{ termLastWord() }}
            <div class="ap-icon-explanation">
                <ap-icon
                    [name]="showExplanation() ? 'chevron-up' : 'chevron-down'"
                    color="inherit"
                    [bordered]="true"
                    [circle]="true"
                    data-testid="explanation-icon"
                >
                </ap-icon>
            </div>
        </span>
    </button>
    @if (showExplanation()) {
        <div class="ap-explain__explanation" data-testid="explanation-text">
            <ng-content></ng-content>
        </div>
    }
</div>
